/**
 * ProvenanceBadge — how a field's value is backed:
 *   grounded  — the exact string appears in the PDF text layer
 *   verifier  — the second model independently agreed
 *   los       — matches the Arive LOS mirror row
 *   human     — hand-corrected / promoted by a person
 */
import React from 'react';
import { Tag, TagLabel, Tooltip } from '@chakra-ui/react';

const KINDS = {
  grounded: { color: 'green', label: 'grounded', tip: 'Value appears verbatim in the PDF text layer' },
  verifier: { color: 'blue', label: 'verifier', tip: 'Independent second model agreed on this field' },
  los: { color: 'purple', label: 'LOS', tip: 'Matches the Arive loan mirror' },
  human: { color: 'pink', label: 'human', tip: 'Human-corrected value' },
  edited: { color: 'orange', label: 'edited', tip: 'Edited in this session — not yet promoted' },
};

export default function ProvenanceBadge({ kind, ...rest }) {
  const k = KINDS[kind];
  if (!k) return null;
  return (
    <Tooltip label={k.tip} fontSize="xs" hasArrow>
      <Tag size="sm" colorScheme={k.color} variant="subtle" borderRadius="full" {...rest}>
        <TagLabel fontSize="10px">{k.label}</TagLabel>
      </Tag>
    </Tooltip>
  );
}
